<ndt-extension-group-detail-view
   [extensionGroup]="extensionGroup$ | async"
   [extensionGroupPrivileges]="extensionGroupPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (deleteExtensionGroup)="onDeleteExtensionGroup($event)"
></ndt-extension-group-detail-view>
